// extracted by mini-css-extract-plugin
export default {"showEditsContainer":"SaveEditsPreview_showEditsContainer__VIIgK"};